module.exports = __webpack_public_path__ + "static/images/containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_first.75b2dd6c.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXLeaderboards/components/RewardTooltip/images/medal_first.png
// module id = 1386
// module chunks = 11